/**
 * Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***
 * - Tag: 71
 * - FIX Specification type: char
 * - Mapped type: string
 * @readonly
 * @public
 */
export const AllocTransType = Object.freeze({
    /** New */
    New: '0',
    /** Replace */
    Replace: '1',
    /** Cancel */
    Cancel: '2',
    /** Reversal */
    Reversal: '6',
} as const);

export type AllocTransType = (typeof AllocTransType)[keyof typeof AllocTransType];
